export const names = ["Гуфи", "Нина", "Марина", "Франклибукирун", "Малышок", "Бетман", "Спуди"];
export const colors = ["Зеленый", "Красный", "Синий", "Желтый"];
export const kinds = ["Земная пони", "Единорог", "Пегас", "Аликорн"];
export const isNew = [true, false];



// WEBPACK FOOTER //
// ./src/constants/ponyData.js